import { container } from "./material-kit-react.js"

const footerStyle = {
  footer: {
    padding: "36px 24px 28px",
    textAlign: "center",
    display: "flex",
    zIndex: "2",
    position: "relative",
    background:
      "linear-gradient(180deg, #221448 0%, #1A0F3B 55%, #120A2A 100%)",
    borderTop: "1px solid rgba(118, 40, 255, 0.28)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)",
    fontFamily: "'Outfit', 'Poppins', sans-serif",
  },
  footerAccent: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "120px",
    height: "3px",
    borderRadius: "0 0 4px 4px",
    background: "linear-gradient(90deg, #6411ED, #7628FF)",
    boxShadow: "0 0 14px rgba(118, 40, 255, 0.45)",
  },
  container: {
    ...container,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "18px",
    maxWidth: "1100px",
    width: "100%",
  },
  left: {
    float: "none",
    display: "block",
    width: "100%",
  },
  right: {
    float: "none",
    margin: "0",
    width: "100%",
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px 6px",
  },
  inlineBlock: {
    display: "inline-flex",
    padding: "0px",
    width: "auto",
  },
  block: {
    color: "#EBE7FB",
    padding: "8px 14px",
    fontWeight: "600",
    fontSize: "12px",
    letterSpacing: "0.8px",
    textTransform: "uppercase",
    borderRadius: "8px",
    textDecoration: "none",
    position: "relative",
    display: "block",
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    transition: "color 0.2s ease, background-color 0.2s ease",
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: "rgba(100, 17, 237, 0.22)",
    },
  },
  a: {
    color: "#D7CFEB",
    textDecoration: "none",
    backgroundColor: "transparent",
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontWeight: 600,
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#7628FF",
    },
  },
  copyright: {
    marginTop: "4px",
    color: "#766293",
    fontSize: "13px",
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontWeight: 500,
    letterSpacing: "0.2px",
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: "#FBFAFE",
    },
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px",
  },
};

export default footerStyle;
